import { Icon, Menu, MenuProps } from "@theorgchartdev/storybook";

export const NullableMenu = (
  props: MenuProps & {
    nullifyValue: () => void;
    iconStyle?: React.CSSProperties;
    clearButtonDataTestId?: string;
  }
) => {
  const { nullifyValue, clearButtonDataTestId, ...menuProps } = props;

  const handleCancel = () => {
    nullifyValue();
  };

  const hasValue = props.value != null && props.value !== "";

  return (
    <div
      style={{ position: "relative", flex: 1 }}
      className={
        hasValue
          ? "ocn-cancelable-input-wrapper-with-nullable-button"
          : "ocn-cancelable-input-wrapper-without-nullable-button"
      }
    >
      <Menu {...menuProps} />
      {hasValue && (
        <Icon
          name="close"
          size="small"
          dataTestId={clearButtonDataTestId}
          style={{
            cursor: "pointer",
            position: "absolute",
            transform: "translateY(-50%)",
            top: "50%",
            width: "8px",
            right: "25px",
            ...(props.iconStyle || {})
          }}
          onClick={handleCancel}
        />
      )}
    </div>
  );
};
